export default {
  MANAGE_LEAVE_REQUESTS: {
    title: 'Manage Leave Requests',
    description: 'Request and accept/reject leaves on behalf of other users'
  },
  MANAGE_GOALS: {
    title: 'Manage Goals',
    description: 'Request and accept/reject goals on behalf of other users'
  },
  MANAGE_APPRAISALS: {
    title: 'Manage Appraisals',
    description: 'Review and evaluate the appraisals of other users'
  },
  ADMINISTER_APPRAISALS: {
    title: 'Appraisals Owner',
    description: 'Full admin access to the appraisals module: templates, assignment, and every appraisal company-wide'
  }
};
